import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'
import { Flex, Label, Radio } from 'pcln-design-system'
import { FLIGHT_TYPE_INFO } from '../types'

const FlightTypeLabel = styled(Label)`
  cursor: pointer;
`
export default function FlightTypeRadios({
  flightTypesToDisplay,
  setValue,
  flightType,
  register,
  flights
}: InferProps<typeof FlightTypeRadios.propTypes>) {
  return (
    <>
      {(flightTypesToDisplay as FLIGHT_TYPE_INFO[]).map(flightInfo => (
        <Flex mr={3} alignItems="center" key={flightInfo.id}>
          <FlightTypeLabel fontSize={[10, 12]} fontWeight={500} nowrap>
            <Radio
              id={flightInfo.id}
              data-testid={flightInfo.id}
              name="flightType"
              checked={flightType === flightInfo.flightType}
              value={flightInfo.flightType}
              ref={register}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                // analytics for Flight Type change
                setValue('flightType', e.target.value)
                if (Array.isArray(flights) && flights.length > 1) {
                  setValue('flights', [flights[0]])
                }
              }}
            />{' '}
            {flightInfo.typeLabel}
          </FlightTypeLabel>
        </Flex>
      ))}
    </>
  )
}

FlightTypeRadios.propTypes = {
  flightTypesToDisplay: PropTypes.arrayOf(PropTypes.object).isRequired,
  setValue: PropTypes.func.isRequired,
  flightType: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  flights: PropTypes.arrayOf(PropTypes.object).isRequired
}
